import React, { Component } from "react";
import { withNavigation } from "../withNavigation";
import "../styles/profile.css";

class Profile extends Component {

    constructor(props) {
        super(props);

        this.state = {
            user: null,
            mobile: "",
            address: "",
            upi_id: "",
            bank_name: "",
            account_no: "",
            ifsc: ""
        };
    }


    componentDidMount() {
        let user = this.props.location?.state?.user;

        if (!user) {
            const stored = localStorage.getItem("user");
            if (stored) { user = JSON.parse(stored); }
        }
        if (!user) {
            this.props.navigate("/");
            return;
        }
        this.loadProfile(user);
    }



    loadProfile = async (user) => {
        const res = await fetch("https://api.hi-bigame.online/user/" + user.id, {
    headers: {"Content-Type": "application/json",
      Authorization: `Bearer ${localStorage.getItem("token")}`
    }
  });
        const data = await res.json();
        this.setState({
            user: data,
            mobile: data.mobile || "",
            address: data.address || "",
            upi_id: data.upi_id || "",
            bank_name: data.bank_name || "",
            account_no: data.account_no || "",
            ifsc: data.ifsc || ""
        });
    };



    save = async () => {
        const res = await fetch("https://api.hi-bigame.online/update-profile",
            {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/json",
                         Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                body: JSON.stringify({
                    userId: this.state.user.id,
                    mobile: this.state.mobile,
                    address: this.state.address,
                    upi_id: this.state.upi_id,
                    bank_name: this.state.bank_name,
                    account_no: this.state.account_no,
                    ifsc: this.state.ifsc
                })
            });

        const data = await res.json();
        alert(data.message);
    };




    deleteAccount = async () => {
        const ok = window.confirm("Delete account permanently?");
        if (!ok) return;
        const res = await fetch("https://api.hi-bigame.online/delete-account",
            {
                method: "POST",
                headers: {
                    "Content-Type":
                        "application/json",
                         Authorization: `Bearer ${localStorage.getItem("token")}`
                },
                body: JSON.stringify({
                    userId:
                        this.state.user.id
                })
            });

        const data = await res.json();
        alert(data.message);
        if (data.success) {
            localStorage.removeItem("user");

            this.props.navigate("/", { replace: true });
        }
    };





    render() {

        return (
            <div className="profile-container">

                <div className="profile-card">

                    <h1 className="profile-title">👤 Profile</h1>

                    <input placeholder="Mobile" value={this.state.mobile} onChange={(e) => this.setState({ mobile: e.target.value })}/>

                    <textarea placeholder="Address" value={this.state.address} onChange={(e) => this.setState({ address: e.target.value })}/>

                    <input placeholder="UPI ID" value={this.state.upi_id} onChange={(e) => this.setState({ upi_id: e.target.value })}/>

                    <input placeholder="Bank Name" value={this.state.bank_name} onChange={(e) => this.setState({ bank_name: e.target.value })}/>

                    <input placeholder="Account No" value={this.state.account_no} onChange={(e) => this.setState({ account_no: e.target.value })}/>

                    <input placeholder="IFSC" value={this.state.ifsc} onChange={(e) => this.setState({ ifsc: e.target.value })}/>

                    {/* BUTTONS */}
                    <div className="btn-group">

                        <button className="save-btn" onClick={this.save}> Save</button>

                        <button className="back-btn" onClick={() => this.props.navigate("/home", {  state: { user: this.state.user }})}> Back </button>

                        <button className="delete-btn"  onClick={this.deleteAccount}> ❌ Delete Account</button>

                    </div>

                </div>
            </div>
        );

    }

}

export default withNavigation(Profile);